export class SolicitudAjuste {
    idSolicitud: number;
    descripcion: string;
    estado: string;
    fechaCreacion: Date;
    fechaRespuesta: Date;
    respuesta: string;
    tipoIdFuncionario: string;
    numeroIdFuncionario: string;
    idTurno: number;
    tipoIdJefe: string;
    numeroIdJefe: string;
    horasAjuste: number;
}